import React from 'react';
import { IconProps } from '../types';

export const CryptoIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_9520_40309)">
            <path
                d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M8.00007 19V24L5.26807 26.732"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M24 19V24L26.734 26.734"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M3.5 31C4.88071 31 6 29.8807 6 28.5C6 27.1193 4.88071 26 3.5 26C2.11929 26 1 27.1193 1 28.5C1 29.8807 2.11929 31 3.5 31Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M28.5 31C29.8807 31 31 29.8807 31 28.5C31 27.1193 29.8807 26 28.5 26C27.1193 26 26 27.1193 26 28.5C26 29.8807 27.1193 31 28.5 31Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M16 31C17.3807 31 18.5 29.8807 18.5 28.5C18.5 27.1193 17.3807 26 16 26C14.6193 26 13.5 27.1193 13.5 28.5C13.5 29.8807 14.6193 31 16 31Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path d="M16 26V16" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
            <path
                d="M14.317 5.00001C13.6358 3.56403 12.4863 2.4026 11.0574 1.7067C9.62856 1.0108 8.0054 0.82186 6.45488 1.17096C4.90437 1.52005 3.5188 2.3864 2.52604 3.62753C1.53328 4.86866 0.992432 6.41068 0.992432 8.00001C0.992432 9.58934 1.53328 11.1314 2.52604 12.3725C3.5188 13.6136 4.90437 14.48 6.45488 14.8291C8.0054 15.1782 9.62856 14.9892 11.0574 14.2933C12.4863 13.5974 13.6358 12.436 14.317 11H21L23 13L25 11H29L30 5.00001H14.317Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
            />
        </g>
        <defs>
            <clipPath id="clip0_9520_40309">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
